(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dataview", [], factory);
	else if(typeof exports === 'object')
		exports["dataview"] = factory();
	else
		root["dataview"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 